import OrgPayment from "@/atomic/organisms/orgPayment";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Loading from "@/atomic/atoms/Loading";
import { Link } from "react-router-dom";

export default function HomeView({
  goToVehicles,
  items,
  plate,
  isLoading,
  onChange,
  selectables,
}: PropsView) {
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header 
        title="Débitos"
      />
      <div className="absolute flex w-full justify-center h-[calc(280px)]">
        <img 
          src={"/iStock.png"}
          width={1505}
          height={291}
          alt="iStock"
          className="absolute brightness-50 h-[calc(280px)] object-cover w-full max-w-[calc(900px)] object-top"
        />
      </div>
      <main className="p-1 z-10 mt-[calc(140px)] p-2 w-full flex justify-center h-full text-black h-form">
        <article className="h-full flex flex-col w-[calc(480px)]">
          <div className={`w-full mb-[calc(120px)] pb-[calc(120px)]`}>
            <div className="flex items-center">
              <img 
                src={"/icon-car.png"}
                width={24}
                height={24}
                alt="icon car"
              />
              <p className="ml-1 text-white">Seus veículos:</p>
            </div>
            <div className="p-3 mt-1 bg-white rounded-xl shadow-md flex w-full justify-between">
              <div>
                <p className="text-lg uppercase">{plate}</p>
              </div>
              <button type="button" onClick={goToVehicles}>
                <img 
                  src={"/icon-change.png"}
                  width={24}
                  height={24}
                  alt="Trocar de veículo"
                />
              </button>
            </div>
            <div className="mt-2 mb-2 w-full flex justify-start items-center">
              <p className="text-xs">{items?.totalDebts} passage{items?.totalDebts !== 1 ? 'ns' : 'm'} em aberto</p>
            </div>
            {items?.totalDebts > 0 && <>
              <div className="flex items-center w-full">
                <input 
                  type="checkbox" 
                  name="all" 
                  className="w-6 h-6 accent-green-600"
                  onChange={onChange}
                  checked={items?.groupedDebts?.length === selectables?.length}
                />
                <p className="text-sm ml-6">Selecionar tudo</p>
              </div>
              <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
              <h2 className="text-base text-principal">Débitos</h2>
              <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
              {items?.groupedDebts?.map((item, index) => (
                <div key={index}>
                  <div className="flex items-center w-full">
                    <input 
                      type="checkbox" 
                      name={item.owner}
                      className="w-6 h-6 accent-green-600"
                      onChange={onChange}
                      checked={selectables?.some(selectable => selectable.name === item.owner) ?? false}
                    />
                    <div className="ml-6">
                      <p className="text-base">{item?.owner}</p>
                      <p className="flex text-sm">{item?.debts?.length} passage{item?.debts?.length !== 1 ? 'ns -' : 'm -'}&nbsp;<Link to={`/details/${item?.owner}`}><p className="underline">Detalhes</p></Link></p>
                      <p className="text-base">R$ {item?.total.toFixed(2).replace('.', ',')}</p>
                    </div>
                  </div>
                  <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                </div>
              ))}
            </>}
            {items?.totalDebts === 0 && <div className="w-full flex justify-center items-center flex-col mt-10">
              <img 
                src={process.env.PUBLIC_URL +"/icon-car-front-close.png"}
                width={48}
                height={48}
                alt="Ícone carro"
                className="mt-6"
              />
              <h2 className="mt-1 text-sm text-center">Não existe nenhum débito<br/>em aberto para este veículo.</h2>
            </div>}
            {items?.totalDebts === 0 && <div className="border-1 border border-gray-400 w-full p-4 rounded-lg flex items-center mb-5 mt-20">
              <img 
                src={"/icon-square.png"}
                width={40}
                height={40}
                alt="Informação"
                className="h-[calc(40px)] w-[calc(40px)]"
              />
              <p className="ml-2 text-gray-600 text-sm">Podem existir algumas passagens que ainda não foram recebidas e não foram listadas aqui.</p>
            </div>}
          </div>
          {items?.totalDebts > 0 && <OrgPayment
            plate={plate}
          />}
        </article>
      </main>
      {isLoading && <Loading />}
    </div>
  );
}
